import { render, staticRenderFns } from "./Streaming.vue?vue&type=template&id=2d23dcf8&scoped=true"
import script from "./Streaming.vue?vue&type=script&lang=js"
export * from "./Streaming.vue?vue&type=script&lang=js"
import style0 from "./Streaming.vue?vue&type=style&index=0&id=2d23dcf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d23dcf8",
  null
  
)

export default component.exports